import React from 'react';

import { run_banner_text } from './adapters';

// "Closing June 2026: 240 / 700" while a run is active, linking to the run panel. Not a live
// region: the counter moves every poll (the run panel announces status changes).
const RunBanner = ({ run, on_open }) => {
  const text = run_banner_text(run);
  if (!text) return null;
  return (
    <div className="tp-banner tp-banner-info" data-testid="tp-run-banner">
      {text}{' '}
      <button type="button" className="tp-link" onClick={on_open}>
        Open Needs attention
      </button>
    </div>
  );
};

export default RunBanner;
